import getHelper from '../../../services/getHelper';

export default getHelper('/time-availability');
